import LayerGroup from 'ol/layer/Group';

/**
 * @typedef {Object} AbstractCompositeLayerOptions
 * @property {import("../../map.js").default} map The map.
 */

export default class AbstractCompositeLayer extends LayerGroup {
  /**
     * @constructor
     * @param {AbstractCompositeLayerOptions} options The options.
     */
  constructor(options) {
    if (new.target === AbstractCompositeLayer) {
      throw new TypeError('Cannot construct AbstractCompositeLayer instances directly');
    }

    super();

    /**
         * The map
         * @type {import("../../map.js").default}
         */
    this.map_ = options.map;

    /**
         * The layers interactors.
         * @protected
         * @type {Array<import('ol/interaction/Interaction').default>}
         */
    this.interactions_ = [];
  }

  /**
     * Add a layer in the layer group.
     * @protected
     * @param {import('ol/layer/Base').default} layer The layer to add.
     */
  addLayer_(layer) {
    this.map_.addLayer(layer)
  }

  /**
     * Add intercation in the layer.
     * @protected
     * @param {import('ol/interaction/Interaction').default} interaction The interaction to add.
     */
  addInteraction_(interaction) {
    this.interactions_.push(interaction);
    this.map_.addInteraction(interaction);
  }

  removeInteraction_(interaction) {
    this.map_.removeInteraction(interaction);
  }

  /**
     * Get get state of layer interactions.
     * @return {boolean} True if interactions are activated, else false.
     */
  getActiveInteractions() {
    return this.interactions_[0] && this.interactions_[0].getActive();
  }

  /**
     * Activate/deactivate all managed interactions.
     * @param {boolean} activate True to activate all managed interaction, else false.
     */
  setActiveInteractions(activate) {
    for (const interact of this.interactions_) {
      interact.setActive(activate);
    }
  }
}
